import React from 'react';
import {
  Wrap,
  Typography,
  Washroom,
  Kitchen,
  Button,
  Input,
  BackButton,
  Notifications,
} from '../../components/index';
import { useParams } from 'react-router-dom';
import * as _ from 'lodash';
import Styled from './EditRoom.style';
import { Row, Col } from 'react-styled-flexboxgrid';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { scrollToTop } from '../../helpers/helpers';
import { formatWashroomAnswers } from '../../helpers/formatWashroomAnswers';
import { formatKitchenAnswers } from '../../helpers/formatKitchenAnswers';
import { parseWashroomAnswers } from '../../helpers/parseWashroomAnswers';
import { parseKitchenAnswers } from '../../helpers/parseKitchenAnswers';
interface EditRoomProps {
  listLocation: any;
  updateEditKeys: Function;
  editRoom: Function;
  room: any;
  resetEditRoom: Function;
}

const EditRoom: React.FC<EditRoomProps> = (props) => {
  const { room, listLocation, editRoom, updateEditKeys, resetEditRoom } = props;
  const { roomId, locationId } = useParams();

  const data = _.get(listLocation, 'data.data');
  const findLocation = _.find(data, function (o) {
    return o.id == locationId;
  });

  const [roomAnswers, setRoomAnswers] = React.useState({});

  const getRooms = _.get(findLocation, 'rooms');
  const findRoom = _.find(getRooms, function (o) {
    return o.id == roomId;
  });
  const { done, loading } = _.get(room, 'editRoom.status');

  const editMessage = _.get(room, 'editRoom.data.message');

  const getRoomType = _.get(findRoom, 'type');
  const getRoomData = _.get(findRoom, 'data');
  const getRoomName = _.get(findRoom, 'name');

  const hasInitialised = React.useRef(false);

  const roomAnswersRef = React.useRef(roomAnswers);
  React.useEffect(() => {
    resetEditRoom();

    return () => {
      resetEditRoom();
    };
  }, [resetEditRoom]);
  React.useEffect(() => {
    roomAnswersRef.current = roomAnswers;
  }, [roomAnswers]);

  React.useEffect(() => {
    if (!getRoomType || !getRoomData || hasInitialised.current) {
      return;
    }

    const parsedAnswers =
      getRoomType === 'washroom'
        ? parseWashroomAnswers(getRoomData)
        : parseKitchenAnswers(getRoomData);

    hasInitialised.current = true;

    setRoomAnswers(parsedAnswers);
    updateEditKeys(parsedAnswers);
  }, [getRoomType, getRoomData, updateEditKeys]);

  const EditRoomSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
  });
  const renderForm = () => {
    return (
      <Formik
        initialValues={{
          name: getRoomName ? getRoomName : '',
        }}
        validationSchema={EditRoomSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);

          const currentAnswers = roomAnswersRef.current;

          const formattedData =
            getRoomType === 'washroom'
              ? formatWashroomAnswers(currentAnswers)
              : formatKitchenAnswers(currentAnswers);

          editRoom(roomId, getRoomType, values.name, formattedData);

          scrollToTop();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => {
          return (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Row>
                <Col xs={12} sm={12} md={6}>
                  <Input
                    id="name"
                    name="name"
                    value={values.name}
                    type="text"
                    placeholder="Room name*"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.name && touched.name ? errors.name : undefined
                    }
                  />
                </Col>
                <Col md={6} xs={12} sm={12}>
                  <Styled.RoomTypeText>
                    Room type: <span>{getRoomType}</span>
                  </Styled.RoomTypeText>
                </Col>

                <Col md={12} sm={12} xs={12}>
                  {getRoomType === 'washroom' ? (
                    <Washroom
                      initialValues={roomAnswers}
                      onChange={(updatedAnswers) => {
                        roomAnswersRef.current = updatedAnswers;
                        setRoomAnswers(updatedAnswers);
                      }}
                    />
                  ) : (
                    <Kitchen
                      initialValues={roomAnswers}
                      onChange={(updatedAnswers) => {
                        roomAnswersRef.current = updatedAnswers;
                        setRoomAnswers(updatedAnswers);
                      }}
                    />
                  )}
                </Col>
                <Col
                  md={12}
                  xs={12}
                  sm={12}
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    disabled={isSubmitting}
                    isLoading={loading}
                    type="submit"
                  >
                    Edit room
                  </Button>
                </Col>
                {errors.name ? (
                  <Col md={12} sm={12} xs={12}>
                    <Notifications type="ERROR">
                      Room name: {errors.name}
                    </Notifications>
                  </Col>
                ) : null}
              </Row>
            </form>
          );
        }}
      </Formik>
    );
  };

  return (
    <Wrap>
      <Row style={{ marginBottom: '32px' }}>
        <Col md={8} sm={12} xs={12}>
          <Typography size="1" text="Edit room" />
        </Col>
        <Col md={4} sm={12} xs={12}>
          <Styled.TopBtnWrap>
            <BackButton />
          </Styled.TopBtnWrap>
        </Col>
      </Row>

      <Row>
        {done ? (
          <Col md={12} sm={12} xs={12}>
            <Styled.Success>
              <Typography text="Success" size="3" />{' '}
              <Typography
                text={
                  typeof editMessage === 'string'
                    ? editMessage
                    : 'Room updated successfully.'
                }
                size="p"
              />
            </Styled.Success>
          </Col>
        ) : (
          <Col md={12} sm={12} xs={12}>
            <Styled.Card>{renderForm()}</Styled.Card>
          </Col>
        )}
      </Row>
    </Wrap>
  );
};

export default EditRoom;
